import React from 'react';


import {
    View,
    StyleSheet,
    ScrollView,
    Image,
    Dimensions,
    Text,

    Alert,
    Keyboard,
    Switch,
    ImageBackground, TouchableOpacity, TextInput
} from "react-native";

import {RFValue} from "react-native-responsive-fontsize";
import {AntDesign, Ionicons} from "@expo/vector-icons";
import Config from "../components/Config";



import { Formik } from 'formik';
import * as Yup from "yup";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";


// import Toast from "react-native-tiny-toast";
import ToastNotification from 'react-native-toast-notification'


import * as ImagePicker from 'expo-image-picker';


const schema = Yup.object().shape({

    full_name : Yup.string().required('field is required').min('5',' Please type more ...'),
});


const Edit = ({navigation})=>{

    let[disable,setDisable] = React.useState(false);
    let[pin,setPin] = React.useState('');
    let [toast,setToast] = React.useState(false);


    let [two,setTwo] = React.useState(false);



    const [image, setImage] = React.useState(null);
    const [imageresult, setImageresult] = React.useState(null);

    let [profile,setProfile] = React.useState({
        reward : '0' ,
        teamReward : '0' ,
        walletAmount : '0',
        full_name : 'Loading ... ',
        withdrawbleAmount : '0',
        avatar :'https://metamax.network/public/no-avatar.jpeg',
        myPack : [],
    });

    React.useEffect(()=>{
        getData();
    },[navigation]);



    const chagetwo = async ()=>{


        let token = await AsyncStorage.getItem('token');



        let formData = new FormData();

        formData.append('token', token);
        formData.append('pin', pin);






        let url;
        if(!two){

           url = `${Config.base}/api/v1/check/code`;
        }else{
            url = `${Config.base}/api/v1/authenticator/off`;
        }



        let res = await axios.post(
            url,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",

                }
            }
        );


        if(res.data.status == 200){
            setTwo(!two);
            // Toast.showSuccess(res.data.message);
        }else{
            // Toast.show(res.data.message);
        }


    }



    const getData = async ()=>{
        let token = await AsyncStorage.getItem('token');


        let res = await axios.get(
            `${Config.base}/api/v1/profile`,
            { params:
                    {
                        token: token
                    }
            }
        );
        profile = res.data;
        setProfile(res.data);

    };


    const pickImage = async () => {
        let result = await ImagePicker.launchImageLibraryAsync({
            mediaTypes: ImagePicker.MediaTypeOptions.Images,
            allowsEditing: true,
            aspect: [1, 1],
            quality: 1,
        });

        if (!result.cancelled) {
            setImageresult(result)
            setImage(result.uri);

        }

    };


    const confirm =async (values)=>{





        let token = await AsyncStorage.getItem('token');



        // Toast.showLoading('Send Data To Server ...');
        setToast('Send Data To Server ...');



        let formData = new FormData();
        formData.append('password', profile.password);
        formData.append('token', token);
        formData.append('full_name', values.full_name);
        formData.append('about', profile.about);






        if(image){

            let localUri = imageresult.uri;
            let filename = localUri.split('/').pop();

            // Infer the type of the image
            let match = /\.(\w+)$/.exec(filename);
            let type = match ? `image/${match[1]}` : `image`;

            formData.append('avatar', { uri: localUri, name: filename, type });
        }



        setDisable(true);


        let res = await axios.post(
            `${Config.base}/api/v1/profile/update`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",

                }
            }
        );
        setDisable(false);
        Keyboard.dismiss();



        // Toast.hide('');

        setToast(false);


        if(res.data.status == 200){
            // Toast.showSuccess(res.data.message);
            setToast(res.data.message);
            const timeoutId = setTimeout(() => {
                setToast(false);
            }, 3000);
        }else{
            setToast(res.data.message);
            const timeoutId = setTimeout(() => {
                setToast(false);
            }, 3000);
        }



    }



    return (

        <View style={{flex : 1}}>
            <ImageBackground
                source={{uri: 'https://metamax.network/public/appBg.jpg'}}
                // source={{uri: 'https://img.freepik.com/free-photo/minimalistic-still-life-arrangement-with-cryptocurrency_23-2149102090.jpg?w=740&t=st=1694093218~exp=1694093818~hmac=d9334eec05ae93b0588ef7cd2b5b01df82be982db4bb333380c6e5760732c18e'}}
                resizeMode="cover" style={{flex : 1}}>

                <View style={styles.headercon}>
                    <TouchableOpacity style={{backgroundColor : 'transparent'}} onPress={()=>navigation.goBack()}>
                        <Ionicons   name="return-up-back" size={RFValue(35)} color="#FFF" />
                    </TouchableOpacity>
                    <Text style={styles.header}>
                       Edit Profile
                    </Text>
                </View>


                <View style={styles.box}>
                    <View style={styles.imgmid}>
                        {image ?

                            <Image source={{ uri: image }} style={{borderRadius : RFValue(100), width : RFValue(110),height : RFValue(110) }} />
                            :
                            <Image
                                style={styles.img}
                                source={{
                                    uri: profile.avatar,
                                    width: RFValue(110),
                                    height: RFValue(110),
                                }}
                                blurRadius={0.5}
                                fadeDuration={2000}
                            />
                        }

                    </View>



                    <TouchableOpacity
                        onPress={pickImage}
                                       style={{justifyContent : 'center',alignItems : 'center', marginTop : RFValue(10)}}>
                        <View style={styles.btn2}>
                            <Text  style={styles.btntext}>Select </Text>
                        </View>
                    </TouchableOpacity>




                </View>



                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        'full_name' : profile.full_name,
                    }}
                    validationSchema={schema}
                    onSubmit={ (values)=>{confirm(values)}}>
                    {({ handleChange, handleBlur, handleSubmit, values , errors,setFieldTouched , touched })=>(


                        <View style={{flex : 1,justifyContent : 'flex-start'}}>
                            <ScrollView style={styles.box2}>

                                <View>
                                    <Text style={styles.label}>
                                        Full Name :
                                    </Text>
                                    <View style={{flexDirection : 'row'}}>


                                        <TextInput
                                            style={styles.textinput}
                                            onChangeText={handleChange('full_name')}
                                            value={values.full_name}
                                            onBlur={()=>setFieldTouched('full_name')}
                                            showError={touched.full_name}
                                            error={errors.full_name}
                                        />
                                    </View>
                                    {touched.full_name &&
                                        <>
                                            {errors.full_name &&
                                                <Text style={styles.error}>{errors.full_name}</Text>
                                            }
                                        </>
                                    }
                                </View>

                                {toast.length &&
                                    <ToastNotification
                                        // textStyle={{ color: 'red' }}
                                        // style={{ backgroundColor: 'yellow' }}
                                        text={toast}
                                        // duration={99999999999}
                                        isTop={true}
                                        style={{ padding: RFValue(10) }}
                                    />
                                }
                                <View>
                                    <Text style={styles.label}>
                                         Email :
                                    </Text>
                                    <View style={{flexDirection : 'row'}}>


                                        <TextInput
                                            editable={false}
                                            style={styles.textinput}
                                            value={profile.email}
                                        />
                                    </View>

                                </View>
                                <View>
                                    <Text style={styles.label}>
                                        wallet Address :
                                    </Text>
                                    <View style={{flexDirection : 'row'}}>


                                        <TextInput
                                            editable={false}
                                            style={styles.textinput}
                                            value={profile.wallet_address}
                                        />
                                    </View>

                                </View>


                                <View>
                                    <Text style={styles.label}>
                                        Two factor Pin :
                                    </Text>
                                    <View style={{flexDirection : 'row'}}>
                                        <TextInput
                                            style={styles.textinput}
                                            value={pin} keyboardType={"number-pad"} onChangeText={setPin}
                                        />
                                    </View>
                                </View>

                                <View style={{flexDirection : 'row' ,justifyContent : 'space-between'}}>
                                    <Text style={styles.label}>
                                        Two Factor :
                                    </Text>
                                    <Switch
                                        trackColor={{false: '#FFF', true: '#61dafb'}}
                                        thumbColor={two ? '#FFF' : '#000'}
                                        ios_backgroundColor="#3e3e3e"
                                        onValueChange={chagetwo}
                                        value={two}
                                    />

                                </View>





                                <View style={{paddingBottom : RFValue(20)}}>

                                    <TouchableOpacity  disabled={disable}
                                                       onPress={handleSubmit}
                                                       style={{justifyContent : 'center',alignItems : 'center', marginTop : RFValue(20)}}>
                                        <View style={styles.btn2}>
                                            <Text  style={styles.btntext}>Send</Text>
                                        </View>
                                    </TouchableOpacity>
                                </View>


                            </ScrollView>

                        </View>


                    )}

                </Formik>





            </ImageBackground>




        </View>



    );

};
const styles = StyleSheet.create({
    spanStyle : {
        position : 'absolute',
        right : RFValue(10),
        top : RFValue(5),
        color : '#FFF',
        fontSize : RFValue(25)
    },
    recivetext : {
        fontFamily : 'novaria',
        color : '#f6f6f6',
        textAlign : 'center',
        fontSize : RFValue(14),
        display : 'none' ,
        paddingVertical : RFValue(5)
    },

    textfee:{
        fontFamily : 'novaria',
        color : '#e1e1e1',
        // textAlign : 'center',
        fontSize : RFValue(12),
        paddingVertical : RFValue(10),
    },

    error : {
        fontFamily : 'novaria',
        fontSize : RFValue(12),
        color : '#9E2225',
        paddingBottom : RFValue(10),
        paddingHorizontal: RFValue(15),
    },

    label:{
        fontFamily : 'novaria',
        color : '#f6f6f6',
        // textAlign : 'center',
        fontSize : RFValue(16),
        paddingVertical : RFValue(10)
    },

    labe2:{
        fontFamily : 'novaria',
        color : '#f6f6f6',
        // textAlign : 'center',
        fontSize : RFValue(16),
        paddingVertical : RFValue(10),
        flexDirection : 'row',
        justifyContent : "space-between",
    },
    textinput : {
        fontSize : RFValue(16),
        paddingVertical : RFValue(10),
        paddingHorizontal : RFValue(10),
        borderWidth : 1,
        color : '#e1e1e1',
        borderColor : '#f6f6f6',
        width : '99%',
        borderRadius : RFValue(4)

    },


    btn2 : {

        borderWidth : 1,
        borderColor : 'transparent',
        width : '30%',
        margin : "auto",
        justifyContent : "center",
        alignItems: 'center',
        padding : RFValue(5),
        borderRadius : RFValue(5),
        backgroundColor : '#009688'
    },

    btn : {

        borderWidth : 1,
        borderColor : '#FFF',
        width : RFValue(120),
        justifyContent : "center",
        alignItems: 'center',
        padding : RFValue(3),
        borderRadius : RFValue(5),
        backgroundColor : 'transparent',
        marginHorizontal : RFValue(5)
    },

    btntext : {
        color : '#FFF',
        fontFamily : 'novaria',
    },



    box2 : {
        margin : RFValue(12),
        backgroundColor : 'transparent',
        padding:RFValue(10),
        borderRadius : RFValue(10),
        flex : 1,
        // flexDirection : 'row',
    },


    headercon : {
        backgroundColor : 'transparent',
        flexDirection : 'row',
        alignItems : "center",
        paddingVertical : RFValue(3),
        paddingHorizontal : RFValue(25),
        // borderTopWidth : 1,
        // borderTopColor : '#FFF',

        borderBottomWidth : 1,
        borderBottomColor : '#f6f6f6',

    },
    header : {
        fontFamily : 'novaria',
        color : '#FFF',
        textAlign : 'center',
        fontSize : RFValue(20),
        padding : RFValue(20),

        textShadowColor: 'rgba(0, 0, 0, 0.75)',
        textShadowOffset: {width: -1, height: 1},
        textShadowRadius: 3,
        flex : 1,
        marginRight : RFValue(20)

    },


    box : {
        // backgroundColor : '#FFF',
        padding : RFValue(7),
        margin : RFValue(5),
    }
    ,
    imgmid : {
        justifyContent : 'center',
        alignItems : 'center',
    }
    ,
    img :{
        borderRadius : RFValue(100),
        objectFit  : 'cover',
    },


    button : {
        backgroundColor : '#61dafb' ,
        padding:RFValue(10),
        borderRadius:RFValue(5),
        marginTop:RFValue(20),
    }
    ,
    buttontext : {
        color:'white',
        fontFamily:'novaria',
        textAlign:'center',
        fontSize:RFValue(12)
    }



});

export default Edit;
